import { Modal } from '../../../components/Modal/Modal.component';
import { SessionsImagesContent } from './SessionsImagesContent.component.tsx/SessionsImagesContent.component';

interface SessionsImagesDialogProps {
  xCloseButton: () => void;
  onClose: () => void;
  open: boolean;
  sheetId: string;
  id: string;
  title: string;
  sheetSymbol: string;
  isConfigured: boolean;
}

export const SessionsImagesDialog: React.FC<SessionsImagesDialogProps> = ({
  xCloseButton,
  onClose,
  open,
  sheetId,
  id,
  title,
  sheetSymbol,
  isConfigured,
}) => {
  return (
    <Modal xCloseButton={xCloseButton} id={id} open={open} size="xl" title={`Zarządzaj strefą obrazu: ${title}`}>
      <SessionsImagesContent
        sheetId={sheetId}
        sheetSymbol={sheetSymbol}
        onClose={onClose}
        onCancel={xCloseButton}
        isConfigured={isConfigured}
      />
    </Modal>
  );
};
